import ListDropSortableItems from './ListDropSortableItems'
import ListDropZone from './ListDropZone'

const ConditionalWrapper = ({ wrapper, children }) => wrapper ? wrapper(children) : children

const ListDropItems = ({
    listId, 
    title = '',
    items, 
    order,
    itemType,
    dndType=false,
    displayDropzones,
    conditionalWrapper = false,
    ChildSwitchItem,
    params=false,
    dataType=false,
    basicUrl=false,
    basePreviewUrl=null,
    cinemaId,
    canDropCallback=false,
    canEdit = false,
    canDelete = false,  
    addItem,
    flyerPk,
    reorderItem,
    deleteItem = false,
}) => {
    const wrapper = conditionalWrapper ? conditionalWrapper(title) : false

    return (
        displayDropzones ? (
            <ListDropZone
                listId={listId}
                itemType={itemType}
                dndType={dndType}
                wrapper={wrapper}
                canDropCallback={canDropCallback}
                addItem={addItem}
            />
        ) : (
            <ConditionalWrapper wrapper={wrapper}>
                <ListDropSortableItems
                    listId={listId}
                    title={title}
                    items={items}
                    dataType={dataType}
                    order={order}
                    basePreviewUrl={basePreviewUrl}
                    itemType={itemType}
                    dndType={dndType}
                    flyerPk={flyerPk}
                    params={params}
                    basicUrl={basicUrl}
                    cinemaId={cinemaId}
                    ChildSwitchItem={ChildSwitchItem}
                    canEdit={canEdit}
                    canDelete={canDelete}
                    reorderItem={reorderItem}
                    deleteItem={deleteItem}
                />
            </ConditionalWrapper>
        )
    )
}

export default ListDropItems